import React from 'react'
import { ViewProps } from 'react-native'

import { colors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { Stack } from '@zet/design-system/layout'

interface CloseButtonType extends ViewProps {
  handleClose: () => void
}
export const CloseButton = ({ handleClose, ...props }: CloseButtonType) => {
  return (
    <Stack {...props}>
      <Icon
        type="Close"
        size={30}
        color={colors.grays[100]}
        onPress={handleClose}
      />
    </Stack>
  )
}
